var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesAtPricePoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 29h22a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v17h-2V15a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v12h-2v-7.988a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1V27H6a.997.997 0 0 1-1-1V4a1 1 0 0 0-2 0v22c0 .796.316 1.559.879 2.121A2.996 2.996 0 0 0 6 29Z",
    fill: "#75b6e1",
    className: "fill-000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.003 4H10a3.001 3.001 0 0 0 0 6h2a1 1 0 0 1 0 2H9a1 1 0 0 0 0 2h1.003v1a1.001 1.001 0 0 0 2 0v-1A3.001 3.001 0 0 0 12 8h-2a1 1 0 0 1 0-2h3a1 1 0 0 0 0-2h-.997V3a1 1 0 0 0-2 0v1Z",
    fill: "#75b6e1",
    className: "fill-000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesAtPricePoint);
export default __webpack_public_path__ + "static/media/sales_at_price-point.9b1ec01edc440593352a89992efa8680.svg";
export { ForwardRef as ReactComponent };